import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { CalendarCheck, CalendarClock, ArrowRight } from "lucide-react";

const MONTH = new Date().toLocaleString("en-GB", { month: "long" });

export function MonthlyAuditBanner({ done, monthlyCount = 0, audited, sampleSize }) {
  if (done == null) return null;
  const started = audited > 0;
  const tone = done ? "bg-rag-green-bg border-rag-green/30 text-rag-green" : "bg-coral/10 border-coral/30 text-brand";
  const Icon = done ? CalendarCheck : CalendarClock;
  const title = done ? `${MONTH} resident audit underway` : `${MONTH} resident audit due`;
  const body = done
    ? `${monthlyCount} of ${sampleSize} residents dated this month — keep going to complete the sample.`
    : `0 of ${sampleSize} residents dated this month. Audit ${sampleSize} residents (16 questions each, about 20 minutes). ${started ? "Audits without a date this month don't count — check each resident's Date audited." : "Not yet started."}`;
  return (
    <div data-testid="monthly-audit-banner" className={`flex flex-wrap items-center gap-3 rounded-xl border px-4 py-3 mb-5 text-sm ${tone}`}>
      <Icon className="h-5 w-5 shrink-0" />
      <div className="flex-1 min-w-[200px]"><span className="font-semibold">{title}</span><span className="text-foreground/70" data-testid="monthly-audit-count"> · {body}</span></div>
      {!done && (
        <a href="#resident-audit" data-testid="monthly-audit-start" className="inline-flex items-center gap-1 rounded-full bg-coral text-white px-4 py-1.5 text-xs font-semibold hover:bg-coral-hover transition-colors">
          Start audit <ArrowRight className="h-3.5 w-3.5" />
        </a>
      )}
    </div>
  );
}

export function useAuditDeepLink(ready) {
  const [params, setParams] = useSearchParams();
  useEffect(() => {
    if (!ready) return;
    const target = params.get("audit") === "residents" ? "resident-audit" : params.get("review") === "overview" ? "review-overview" : params.get("records") === "referrals" ? "dental-referrals" : null;
    if (!target) return;
    const el = document.getElementById(target);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    params.delete("audit"); params.delete("review"); params.delete("records");
    setParams(params, { replace: true });
  }, [ready, params, setParams]);
}
